import { TsRestClient } from '@eluve/api-client-provider';
import { Logger } from '@eluve/logger-main';

import { PrepareAudioRecordsEvent, TaskHandler } from '../types';

export const prepareAudioRecordsHandler = ({
  client,
  logger,
}: {
  client: TsRestClient | null;
  logger: Logger;
}): TaskHandler<PrepareAudioRecordsEvent> => {
  return async (task, context) => {
    if (!client) {
      logger.error('Client is not available for preparing audio records', {
        fileName: task.fileName,
      });
      throw new Error('API client not available');
    }

    const response = await client.appointments.prepareAppointmentAudioRecords({
      params: {
        tenantId: context.tenantId,
        appointmentId: task.appointmentId,
      },
      body: {
        fileName: task.fileName,
        useResumableUploads: task.useResumableUploads,
        origin: task.origin,
        userAgent: task.userAgent,
        microphoneName: task.microphoneName,
      },
    });

    if (response?.status !== 200) {
      logger.error('Failed to prepare appointment audio records', {
        fileName: task.fileName,
      });

      throw new Error('Failed to prepare appointment audio records');
    }
  };
};
